export default __webpack_public_path__ + "static/media/Hand.9e6cc508.svg";